import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './current/App';

import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import Info from "./current/Info";

const publicUrl = process.env.PUBLIC_URL || '';
ReactDOM.render(
  <React.StrictMode>
      <Router basename={`${publicUrl}`}>
          <Switch>
              <Route path="/info" component={Info}/>
              <Route path="*" component={App}/>
          </Switch>
      </Router>

  </React.StrictMode>,
  document.getElementById('root')
);
